module.exports = __webpack_public_path__ + "static/media/Marker_Pen.e588cd92.svg";